import { Logger } from '@/shared/logger/logger';

export const GenericJsonUtils = {
  isValidJsonString(jsonString: string) {
    if (!(jsonString && typeof jsonString === 'string')) {
      return false;
    }

    try {
      JSON.parse(jsonString);
      return true;
    } catch {
      return false;
    }
  },
};

export class JSONHelper<T> {
  /**
   * Converts an object of type T to a JSON string.
   * @param obj - The object to be stringified.
   * @returns The JSON string representation of the object.
   */
  stringify(obj: T): string {
    try {
      return JSON.stringify(obj);
    } catch (error) {
      Logger.error('Failed to stringify object:', error);
      throw new Error('Stringify failed');
    }
  }

  /**
   * Converts a JSON string back to an object of type T.
   * @param jsonString - The JSON string to be parsed.
   * @returns The parsed object of type T.
   */
  unstringify(jsonString: string): T | null {
    try {
      return JSON.parse(jsonString) as T;
    } catch (error) {
      Logger.error(`Failed to parse JSON string: ${jsonString}}`, error);
      return null;
    }
  }
  /**
   * Safe method to stringify an object, with an optional default string.
   * @param obj - The object to be stringified.
   * @param defaultString - The default string to return in case of a stringification error.
   * @returns The JSON string representation of the object or the default string.
   */
  safeStringify(obj: T, defaultString = ''): string {
    try {
      return JSON.stringify(obj);
    } catch {
      Logger.warn(
        'Failed to stringify object, returning default string:',
        // error,
      );
      return defaultString;
    }
  }

  /**
   * Safe method to parse a JSON string, with an optional default value.
   * @param jsonString - The JSON string to be parsed.
   * @param defaultValue - The default value to return in case of a parsing error.
   * @returns The parsed object of type T or the default value.
   */
  safeUnstringify(jsonString: string, defaultValue: T): T {
    try {
      return JSON.parse(jsonString) as T;
    } catch {
      Logger.warn(
        `Failed to parse JSON string ${jsonString}, returning default value:`,
        // error,
      );
      return defaultValue;
    }
  }
}
